import { PageType } from "../../constants";
import { OnboardingError } from "../../models/errors";
import { Programs } from "../../models/programsConfig";
import {
  AaaApplicationStep,
  IdXboxApplicationStep,
  PitchApplicationStep,
} from "../../models/status";
import { StatusScope } from "../scopes";
import { createOnboardingAction } from "./helpers/actionCreators";

export enum StatusActions {
  UPDATE_STEP = "@status/UPDATE_STEP",
  UPDATE_CURRENT_PROGRAM = "@status/UPDATE_CURRENT_PROGRAM",
  UPDATE_CURRENT_PAGE_TYPE = "@status/UPDATE_CURRENT_PAGE_TYPE",
  INITIAL_CRM_FETCH_COMPLETED = "@status/INITIAL_CRM_FETCH_COMPLETED",
  UPDATE_ERROR = "@stats/UPDATE_ERROR",
  UPDATE_IS_SAVING_FORM = "@stats/UPDATE_IS_SAVING_FORM",
  UPDATE_IS_SUBMITTING = "@status/UPDATE_IS_SUBMITTING",
  UPDATE_IS_LOADING_GAME_CONCEPT = "@status/UPDATE_IS_LOADING_GAME_CONCEPT",
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const statusActions: any = {
  updateStep: createOnboardingAction(
    StatusActions.UPDATE_STEP,
    StatusScope,
    (
      statusStep: AaaApplicationStep | IdXboxApplicationStep | PitchApplicationStep,
      program: Programs
    ) => ({
      statusStep,
      program,
    })
  ),
  updateCurrentPageType: createOnboardingAction(
    StatusActions.UPDATE_CURRENT_PAGE_TYPE,
    StatusScope,
    (pageType: PageType | undefined) => ({
      pageType,
    })
  ),
  updateCurrentProgram: createOnboardingAction(
    StatusActions.UPDATE_CURRENT_PROGRAM,
    StatusScope,
    (program: Programs) => ({
      program,
    })
  ),
  initialCrmFetchCompleted: createOnboardingAction(
    StatusActions.INITIAL_CRM_FETCH_COMPLETED,
    StatusScope,
    (pageType: PageType | undefined) => ({ pageType })
  ),
  updateIsSavingForm: createOnboardingAction(
    StatusActions.UPDATE_IS_SAVING_FORM,
    StatusScope,
    (isSavingForm: boolean) => ({
      isSavingForm,
    })
  ),
  updateIsSubmitting: createOnboardingAction(
    StatusActions.UPDATE_IS_SUBMITTING,
    StatusScope,
    (isSubmitting: boolean) => ({
      isSubmitting,
    })
  ),
  updateIsLoadingGameConcept: createOnboardingAction(
    StatusActions.UPDATE_IS_LOADING_GAME_CONCEPT,
    StatusScope,
    (isLoadingGameConcept: boolean) => ({
      isLoadingGameConcept,
    })
  ),
  updateError: createOnboardingAction(
    StatusActions.UPDATE_ERROR,
    StatusScope,
    (error: OnboardingError | undefined) => ({
      error,
    })
  ),
};
